// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__VyOb6","row":"ProcedureTreatmentSummary_row__2hcnP"};